module.exports = __webpack_public_path__ + "img/sign1.da383513.png";